<template>
  <div>
    <datatable
      @create="createHistoryCompany"
      :show_delete="false"
      title="Company History Companies"
      @edit_click="editClick"
      :fields="fields"
      :response="data"
    ></datatable>
  </div>
</template>
<script>
import { mapMutations } from 'vuex'
import DataTable from '@/components/DataTable.vue'
export default {
  name: 'company-history-companies',
  data () {
    return {
      fields: [
        {
          name: 'id',
          value: 'id'
        },
        {
          name: 'name',
          value: 'name'
        },
        {
          name: 'description',
          value: 'description'
        }
      ],
      data: [],
      operations: [],
      company_id: this.$route.query.company_id
    }
  },
  created: function () {
    this.init()
  },
  methods: {
    init () {
      this.$network_utils
        .getCompanyHistoryCompanies({
          current_company_id: this.company_id
        })
        .then(response => {
          this.data = response
        })
    },
    createHistoryCompany () {
      this.create({ designator: 'company-history-companies-form-modal', component_name: 'CompanyHistoryCompaniesForm', is_create: true, company_id: this.company_id, modal_title: 'Create new History Company' })
    },
    editClick (data) {
      this.create({ designator: 'company-history-companies-form-modal', component_name: 'CompanyHistoryCompaniesForm', data, company_id: this.company_id, modal_title: data.name })
    },
    ...mapMutations('modals', ['create'])
  },
  components: {
    datatable: DataTable
  }
}
</script>
